import React from "react";

/**
 * Tooltip for FleetRangeDistributionChart.
 * Rendered to an HTML string via ReactDOMServer.renderToStaticMarkup and
 * supplied to ApexCharts tooltip.custom — matching the default ApexCharts
 * light-theme tooltip appearance.
 *
 * Props:
 *   project        {string}  – y-axis category (e.g. "314 kWh")
 *   series         {Array}   – [{ label, color, value }, ...]
 *   certifiedRange {number}  – certified range value in km
 */
const FleetRangeDistributionTooltip = ({ project, series, certifiedRange }) => {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e3e3e3",
        borderRadius: "5px",
        boxShadow: "0px 0px 17px -3px rgba(0,0,0,0.1)",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "12px",
        color: "#373d3f",
        minWidth: "140px",
        overflow: "hidden",
      }}
    >
      {/* Title row — matches .apexcharts-tooltip-title */}
      <div
        style={{
          background: "#ECEFF1",
          padding: "6px 13px",
          marginBottom: "4px",
          fontSize: "13px",
          fontWeight: 700,
          borderBottom: "1px solid #ddd",
          color: "#373d3f",
        }}
      >
        {project}
      </div>

      {/* Series rows — matches .apexcharts-tooltip-series-group */}
      {series.map(({ label, color, value, min, max }) => (
        <div
          key={label}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "6px 10px 10px",
          }}
        >
          <span
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              background: color,
              marginRight: "10px",
              flexShrink: 0,
              display: "inline-block",
            }}
          />

          <div>
            <span>
              {label} ({min ?? "-"} - {max ?? "-"} Km/Full Charge) :{" "}
            </span>
            <span style={{ fontWeight: 700 }}>{value}</span>
          </div>
        </div>
      ))}

      {/* Certified Range row */}
      <div
        style={{
          borderTop: "1px solid #e3e3e3",
          margin: "4px 0 0",
          padding: "5px 13px 8px",
        }}
      >
        <span>Certified Range : </span>
        <span style={{ fontWeight: 700 }}>{certifiedRange} km</span>
      </div>
    </div>
  );
};

export default FleetRangeDistributionTooltip;
